import {
  postRequest,
  patchRequest,
  postFormDataRequest,
  getRequest,
  deleteRequest
} from "../lib/utils/request";

export const getAllAPI = async (
  apiHost,
  { limit, offset, sortField, sortDir, search },
  requestOptions
) => {
  return await getRequest(
    `${apiHost}/v1/agencies?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}&searchName=${search.name}`,
    requestOptions
  );
};

export const getAPI = async (apiHost, { uid }, requestOptions) => {
  return await getRequest(`${apiHost}/v1/agencies/${uid}`, requestOptions);
};

export const createAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(`${apiHost}/v1/agencies`, data, requestOptions);
};

export const updateAPI = async (apiHost, data, requestOptions) => {
  return await patchRequest(
    `${apiHost}/v1/agencies/${data.uid}`,
    data,
    requestOptions
  );
};

export const deleteAPI = async (apiHost, { uid }, requestOptions) => {
  return await deleteRequest(`${apiHost}/v1/agencies/${uid}`, requestOptions);
};

export const createLogoAPI = async (apiHost, formData) => {
  return await postFormDataRequest(`${apiHost}/v1/files?type=image`, formData);
};



// WEBPACK FOOTER //
// ./src/common/agency/api.js